import { SAVE_SIDE_MENU, SAVE_ACCESS_TOKEN, SAVE_USER_INFO, LOG_OUT, SAVE_TOKEN_LIST, SAVE_ROUTES } from "../types/types";
import api from "../../Architecture/api";
import commonHelper from "components/Config/common/common.helper";

export const generateMenuAndRoutes = (moduleDBList) => {
	let routes = [];
	const traverseMenu = (menuList, parentPath = "") => {
		menuList.forEach((item) => {
			const fullPath = `${parentPath}${item.route}`;
			if (item.ChildList && item.ChildList.length > 0) traverseMenu(item.ChildList, fullPath);
			routes.push({ ...item, route: fullPath });
		});
	};
	traverseMenu(moduleDBList);
	return { routes };
};

// Usage



export const loginAction = (data) => async (dispatch) => {
	return new Promise(async (resolved, reject) => {
		const result = await api.post("/sign-in", data);
		if (result.success) {
			dispatch(saveAccessToken({ accessToken: result.data.tokens.accessToken, refreshToken: result.data.tokens.refreshToken }));
			localStorage.setItem("userData", JSON.stringify({ accessToken: result.data.tokens.accessToken, refreshToken: result.data.tokens.refreshToken }));
			
			dispatch(saveUserinfo(result.data.userData));
			if (Array.isArray(result?.data?.permissions)) {
				const structuredData = commonHelper.buildHierarchy(result?.data?.permissions);
				const { routes } = generateMenuAndRoutes(structuredData);
				dispatch(saveRoutes(routes));
				dispatch(saveSideMeny(structuredData));
			} else {
				dispatch(saveSideMeny([]));
			}
			let tokenList = { pointofindia: { accessToken: result.data.tokens.accessToken, refreshToken: result.data.tokens.refreshToken } };
			dispatch(saveTokenList(tokenList));
			resolved(result);
		} else {
			reject(result);
		}
	});
};

export const logoutAction = () => async (dispatch) => {
	try {
		await api.post("/logout", {});
	} catch (err) {

	}
	dispatch(logout());
	return true;
};

export const saveAccessToken = (token) => {
	return { type: SAVE_ACCESS_TOKEN, payload: token };
};

export const logout = () => ({
	type: LOG_OUT,
	payload: {},
});

export const saveSideMeny = (menuList) => ({ type: SAVE_SIDE_MENU, payload: menuList });

export const saveRoutes = (routesList) => ({ type: SAVE_ROUTES, payload: routesList });

export const saveUserinfo = (data) => ({ type: SAVE_USER_INFO, payload: data });

export const saveTokenList = (data) => ({ type: SAVE_TOKEN_LIST, payload: data });

export const refreshTokenAction = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const result = await api.post("/refresh-token", data);

			if (!result.success) return reject(result);

			// Handle success (update tokens in Redux + localStorage)
			const { accessToken, refreshToken } = result.data.tokens;
			resolve({ accessToken, refreshToken, success: true });
		} catch (err) {
			reject(err);
		}
	});
};
export const changePassword = (body) => {
	return api.post(`/reset-password`, body);
};
export const forgetPassword = (body) => {
	return api.post(`/forgot-password`, body);
};

export const createUser = (body) => {
	return api.post(`/create-user`, body);
};

export const updateUser = (body) => {
	return api.put(`/update-user`, body);
};

export const getUser = (body) => {
	return api.get(`/users`, body);
};

